export const ZONE_LIST = [
  { label: 'زون 1', value: 1 },
  { label: 'زون 2', value: 2 },
  { label: 'زون 3', value: 3 },
  { label: 'زون 4', value: 4 },
  { label: 'زون 5', value: 5 },
];
